import React from 'react';
import { Form, Formik } from 'formik';

import TopLabel from '@/components/common/TopLabel/TopLabel';
import Input from '@/components/common/Input/Input';
import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import Button, { ButtonStyleType } from '@/components/common/Button/Button';
import { Fields, initialValues, validationSchema } from './validationSchema';
import { ValidationAlert } from '@/components/common/ValidationAlert/ValidationAlert';
import { CreateReasonCodeDto } from '../../hooks/useCreateReasonCode';
import ActionButtonsWrapper from '@/components/common/ModalWindow/ActionButtonsWrapper/ActionButtonsWrapper';

interface IAddNewReasonModalProps {
  reasonType: ReasonType;
  onClose: () => void;
  onSubmit: (newReasonCode: CreateReasonCodeDto) => void;
}

export default function AddNewReasonModal({
  onClose,
  onSubmit,
  reasonType
}: IAddNewReasonModalProps) {
  return (
    <AgModalWindow
      title="Reason Name"
      isOpen={true}
      onClose={onClose}
      contentStyle={{ width: 350 }}
    >
      <Formik<Fields>
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnMount={true}
        onSubmit={(values) => {
          onSubmit({
            code: values.reasonCode,
            name: values.reasonName,
            type: reasonType.type
          });
        }}
      >
        {({ errors, values, touched, isValid, setFieldValue, setFieldTouched }) => (
          <Form>
            <div className="row d-flex align-items-center mb-15">
              <div className="col-4">
                <TopLabel withMargin={false} label="Reason Type" />
              </div>
              <div className="col-8">
                <Input disabled={true} value={reasonType.formattedType} />
              </div>
            </div>

            <div className="row d-flex align-items-center mb-25">
              <div className="col-4">
                <TopLabel
                  required={true}
                  id="reasonCode"
                  withMargin={false}
                  label="Reason Code"
                />
              </div>
              <div className="col-8">
                <ValidationAlert
                  isVisible={Boolean(errors.reasonCode && touched.reasonCode)}
                  text={errors.reasonCode}
                  isFloating={false}
                >
                  <Input
                    id="reasonCode"
                    value={values.reasonCode}
                    onChange={(e) => {
                      setFieldValue('reasonCode', e.target.value);
                      setFieldTouched('reasonCode', true, false);
                    }}
                  />
                </ValidationAlert>
              </div>
            </div>

            <div className="row d-flex align-items-center">
              <TopLabel
                required={true}
                id="reasonName"
                withMargin={true}
                label="Reason Name"
              />
              <ValidationAlert
                isVisible={Boolean(errors.reasonName && touched.reasonName)}
                text={errors.reasonName}
                isFloating={false}
              >
                <Input
                  id="reasonName"
                  value={values.reasonName}
                  onChange={(e) => {
                    setFieldValue('reasonName', e.target.value);
                    setFieldTouched('reasonName', true, false);
                  }}
                />
              </ValidationAlert>
            </div>

            <ActionButtonsWrapper
              leftButton={(
                <Button
                  buttonStyleType={ButtonStyleType.SECONDARY}
                  onClick={onClose}
                >
                  Cancel
                </Button>
              )}
              rightButton={(
                <Button
                  type="submit"
                  disabled={!isValid}
                  buttonStyleType={ButtonStyleType.PRIMARY}
                >
                  Save
                </Button>
              )}
            />
          </Form>
        )}
      </Formik>
    </AgModalWindow>
  );
}
